var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.9744L5 3.36105",
    stroke: "#06C86B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.8411V6.72996C16.9997 6.4182 16.9174 6.11201 16.7614 5.8421C16.6054 5.57219 16.3811 5.34806 16.1112 5.19218L9.88891 1.63662C9.61866 1.48058 9.31209 1.39844 9.00002 1.39844C8.68795 1.39844 8.38139 1.48058 8.11113 1.63662L1.88889 5.19218C1.6189 5.34806 1.39465 5.57219 1.23863 5.8421C1.08262 6.11201 1.00032 6.4182 1 6.72996V13.8411C1.00032 14.1528 1.08262 14.459 1.23863 14.7289C1.39465 14.9989 1.6189 15.223 1.88889 15.3789L8.11113 18.9344C8.38139 19.0905 8.68795 19.1726 9.00002 19.1726C9.31209 19.1726 9.61866 19.0905 9.88891 18.9344L16.1112 15.3789C16.3811 15.223 16.6054 14.9989 16.7614 14.7289C16.9174 14.459 16.9997 14.1528 17 13.8411Z",
    stroke: "#06C86B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24023 5.80551L9.00025 10.2944L16.7603 5.80551",
    stroke: "#06C86B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.2455V10.2855",
    stroke: "#06C86B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.d4b24829f400046a650a336ef20f9dd3.svg";
export { ForwardRef as ReactComponent };